<template>
  <CarouselAdvert></CarouselAdvert>
  <div class="category_title_menu">
    <div style="height: 40px; ">
      <div style="
          text-align: center;
          font-size: 16pt;
          background-color: #fff;
          height: 40px;
          line-height: 40px;
        ">
        {{ CollectionOpt.Name }}
      </div>
    </div>
 
    <van-tabs v-model:active="active" @change="beforeChange" color="#3ca7f0" scrollspy sticky style="width: 100%;">
      <van-tab class="category_title_tab" v-for="(item, index) in CollectionOpt.CategorySimpleModel" :key="index">
        <template #title> {{ item.Name }} </template>
        <div class="category_content_itemtitle">
          {{ item.Name }}
        </div>
        <div style="height: 600px" v-if="item.Products.length == 0">
          <van-empty :description="tools.GetLanguageValue('public.app.正在加载')" />
        </div>
        <div class="product_content" v-for="(product, indexs) in item.Products" :key="indexs">
 
          <div class="product_item" v-if="product != null">
            <StoreProductCollection :ImageHeigth="ProductImageHeigth" :update="UpdateProducts" :ProductItem="product"
              :CollectionId="CollectionId" :OrderId="OrderId" :CartId="CartId" />

          </div>
        </div>
      </van-tab>
    </van-tabs>
    <p style="text-align: center">Powered by Jiecheng</p>
    <br />
    <br />
    <br />
    <br />
    <br />
  </div>

  <StoreShoppingCartTabbar :Carts="Carts"  :placeOrder="()=>{}" :update="UpdateProducts" />

  <van-floating-bubble v-if="!ViewCollectionInfoWindow && AppSystemSettings.IsTaocanInfo" @click="() => {
      ViewCollectionInfoWindow = true;
      GetViewCollectionInfo();
    }
    " v-model:offset="offset" axis="xy" icon="info-o" magnetic="x" />

  <div v-if="ViewCollectionInfoWindow && AppSystemSettings.IsTaocanInfo" class="ViewCollectionInfo">
    <van-icon name="cross" size="22" @click="ViewCollectionInfoWindow = false" color="#fff" style="margin: 5px" />
    <van-cell-group>
      <van-cell v-if="ViewCollectionInfo.RestrictType != 'Time'" :title="tools.GetLanguageValue('public.app.时间间隔')"
        :value="ViewCollectionInfo.ResidueTime + '/' + ViewCollectionInfo.IntervalTime
          " />
      <!-- <van-cell title="剩余时间" :value="ViewCollectionInfo.ResidueTime" /> -->
      <!-- <van-cell title="每次数量" :value="ViewCollectionInfo.ThisTimeCount+'/'+ViewCollectionInfo.EveryCount" /> -->
      <van-cell :title="tools.GetLanguageValue('public.app.下单次数')" :value="ViewCollectionInfo.OrdeCount" />
      <van-cell :title="item.Key" :value="item.Value" v-for="(item, index) in ViewCollectionInfo.ProductSubdivisions"
        :key="index" />
    </van-cell-group>
  </div>
</template>
<script>
import axios from "../../commons/AxiosMethod.js";
import StoreProductCollection from "../../components/Stores/StoreProductCollection.vue";
import StoreShoppingCartTabbar from "../../components/tabbars/StoreShoppingCartTabbar.vue";
import { showToast } from "vant";
import tools from "../../commons/tools.js";
import CarouselAdvert from "../../components/CarouselAdvert.vue";
import { Collapse, CollapseItem, Tab, Tabs } from "vant";
export default {
  data() {
    return {
      index: 0,
      offset: { x: document.body.clientWidth - 50, y: 200 },
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      ViewCollectionInfoWindow: false,
      ViewCollectionInfo: [],
      active: "",
      tools: tools,
      CollectionOpt: {}, // 当前合集
      CollectionPriceInfo: null,

      CollectionId: "", // 合集ID
      OrderId: "", // 订单ID
      CartId: "", // 购物车ID
      Carts: {},
      AppSystemSettings: {
        IsTaocanInfo: false
      },

      ProductImageHeigth: 100
    };
  },
  name: "App",
  mounted() {
    this.CollectionId = this.$route.query.collectionId;
    this.OrderId = this.$route.query.orderId;
    this.CartId = this.$route.query.cartId;
    this.TableId = localStorage.getItem("Cache-TableId");

    this.ProductImageHeigth = localStorage.getItem("ProductImageHeigth");

    this.GetCollections();
    this.GetShoppingCartComplete();

    try {
      // IsTaocanInfo
      this.AppSystemSettings = JSON.parse(localStorage.getItem("AppSystemSettings"));
    } catch (e) { }
  },
  components: {
    StoreProductCollection,
    StoreShoppingCartTabbar,
    CarouselAdvert,
  },
  methods: {
    //查看套餐信息
    GetViewCollectionInfo() {
      axios.apiMethod(
        "/Store/StoreOrder/ViewCollectionInfo",
        "get",
        { tableId: this.TableId },
        (result) => {
          this.ViewCollectionInfo = result.Data;
          this.TimerResidue = setInterval(() => {
            this.ViewCollectionInfo.ResidueTime--; // 每隔1秒自增计数器值
            if (this.ViewCollectionInfo.ResidueTime <= 0) {
              this.ViewCollectionInfo.ResidueTime = 0;
              clearInterval(this.TimerResidue);
            }
          }, 1000); // 设置间隔为1秒
        }
      );
    },

    UpdateProducts() {
      this.GetCollectionPriceInfo();
    },
    // 获取套餐价格信息
    GetCollectionPriceInfo() {
      axios.apiMethod(
        "/shoppings/Collection/GetCollectionPriceInfo",
        "get",
        {
          collectionId: this.CollectionId,
          tableId: this.TableId,
        },
        (result) => {
          this.CollectionPriceInfo = result.Data;
          this.CollectionPriceFormat();
          this.ViewCollectionInfoWindow = false;
        },
        (e) => { }
      );
    },
    // 格式化套餐价格
    CollectionPriceFormat() {
      if (this.CollectionOpt != null) {
        if (this.CollectionPriceInfo != null) {
          // 加载之后改变价格
          for (
            var i = 0;
            i < this.CollectionOpt.CategorySimpleModel.length;
            i++
          ) {
            this.CollectionOpt.CategorySimpleModel[i].Products.forEach(
              (product) => {
                this.CollectionPriceInfo.forEach((e) => {
                  if (e.Id == product.Id) {
                    product.Price = e.Price;
                    product.PriceFormat = e.PriceFormat;
                    product.Count = e.Count;
                    product.PlaceCount = e.PlaceCount;
                    product.AddIsConfirm = e.AddIsConfirm;
                    console.log(" product.AddIsConfirm :"+ product.AddIsConfirm )
                  }
                });
              }
            );
          }
        }
      }
    },

    // 获取购物车
    GetShoppingCartComplete() {
      axios.apiMethod(
        "/Store/StoreOrder/GetShoppingCart",
        "get",
        {
          TableId: this.TableId,
        },
        (result) => {
          this.Carts = result.Data;

          this.$store.commit({
            type: "updateCart",
            carts: this.Carts,
          });
        },
        (e) => { }
      );
    },
    // 获取合集
    GetCollections() {
      axios.apiMethod(
        "/shoppings/Collection/GetCollectionCategorySimple",
        "get",
        {
          collectionId: this.CollectionId,
          tableId: this.TableId,
        },
        (result) => {
          this.CollectionOpt = result.Data;
          this.GetCollectionPriceInfo();
          for (
            var i = 0;
            i < this.CollectionOpt.CategorySimpleModel.length;
            i++
          ) {
            if (i < 3) {
              this.GetCollectionCategoryProduct(
                this.CollectionOpt.CategorySimpleModel[i]
              );
            }
          }
        }
      );
    },

    // 触发切换
    beforeChange(number, name) {
      if (this.CollectionOpt.CategorySimpleModel.length < number + 1) {
        return;
      }

      if (number > 2) {
        var categoryj1 = this.CollectionOpt.CategorySimpleModel[number - 1];
        this.GetCollectionCategoryProduct(categoryj1);
        var categoryj2 = this.CollectionOpt.CategorySimpleModel[number - 2];
        this.GetCollectionCategoryProduct(categoryj2);
      }

      var category = this.CollectionOpt.CategorySimpleModel[number];
      this.GetCollectionCategoryProduct(category);
      var category2 = this.CollectionOpt.CategorySimpleModel[number + 1];
      this.GetCollectionCategoryProduct(category2);
    },
    // 获取分类下的商品
    GetCollectionCategoryProduct(category) {
      if (category.Products.length == 0) {
        axios.apiMethod(
          "/shoppings/Collection/GetCollectionCategoryProduct",
          "get",
          {
            categoryId: category.Id,
            collectionId: this.$route.query.collectionId,
          },
          (result) => {
            try {
              category.Products = result.Data;
              this.CollectionPriceFormat();
            } catch (e) { }
          }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.category_content_itemtitle {
  font-size: 12pt;
  font-weight: 700;
  font-size: 14pt;
  padding: 10px;
  background-color: #eee;
}

.search_content {
  height: 70px;
  display: flex;

  .search {
    width: 100%;
  }
}

.category_title_menu {
  width: 100%;
  height: 600px;
  top: 0px;
  z-index: 9090000;
  background-color: #eee;
}

.category_title_tab {
  background-color: #eee;
}

.product_content {

  margin: 0 auto;
  padding: 5px !important;

  background-color: #eee;

  .product_item {
    margin: 0 auto;
    width: calc(100% - 5px);
  }
}

.ViewCollectionInfo {
  position: fixed;
  z-index: 65816516516;
  top: 50px;
  right: 0px;
  width: 260px;
  background-color: #01a1ff;
  padding: 10px;
}
</style>
